import api from './api';

const getFaqs = async () => {
  const { data } = await api.get('/faqs');
  return data;
};
const createFaq = async (faqData) => {
  const { data } = await api.post('/faqs', faqData);
  return data;
};
const updateFaq = async (id, faqData) => {
  const { data } = await api.put(`/faqs/${id}`, faqData);
  return data;
};
const deleteFaq = async (id) => {
  await api.delete(`/faqs/${id}`);
};

const faqService = { getFaqs, createFaq, updateFaq, deleteFaq };
export default faqService;